/*
 * Title: Rewards/MobilePointStats.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Lifetime Points head toggle, click on points box to box will expanded.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:1.0.0
 */

import React from "react";
import { connect } from "react-redux";
import LinkTo from "@components/LinkTo";
import Buttonlink from "@components/Button";
import { numberFormat } from "@helpers/common";
import Logo from "@components/Logo";
import FullName from "@components/FullName";
import ProgramBox from "@components/ProgramBox";

type Props = {};
type MyState = {
  name: boolean;
  toggleBox: boolean;
};
class MobilePointStats extends React.Component<Props | any, MyState> {
  state: MyState = {
    name: false,
    toggleBox: false,
  };

  toggleBox = () => {
    this.setState({ toggleBox: !this.state.toggleBox });
  };

  render() {
    const { creator, lifetime_points, pageYOffset } = this.props;
    const cname = creator.creator?.username;
    const pname = creator.program.name;
    return (
      <div
        className={`${this.state.toggleBox ? "h-[650px]" : ""
          } lg:hidden absolute left-0 right-0 transition-opacity duration-500 ${pageYOffset > 232 ? 'hidden opacity-0' : 'opacity-100'}`}>
        <div className="bg-tile relative z-30" onClick={this.toggleBox}>
          <div className="z-10 px-5 pt-5 pb-0">
            {/* Lifetime points box start*/}
            <div
              onClick={this.toggleBox}
              className={`${this.state.toggleBox ? "h-[217px]" : "h-[110px]"
                }  border border-gray-700 bg-body rounded-xl p-5 flex justify-between duration-300 ease-in-out transition-[height]`}>
              <div className={` ${this.state.toggleBox ? 'mt-[70px]' : '-mt-1.5'} "transition-transform duration-300 ease-in-out flex flex-col justify-center h-full"`}>
                <p className="tile-inlay-primary opacity-50 text-[14px] uppercase tracking-widest font-semibold">
                  lifetime points
                </p>
                <h1
                  className={`${this.state.toggleBox ? "text-[60px]" : "text-[40px]"
                    }  tile-inlay-primary font-semibold duration-300 ease-in-out transition-[font-size] leading-tight`}>
                  {numberFormat(this.props.score.lifetime_points)}
                </h1>
                
                  <h4
                    className={`${this.state.toggleBox
                      ? "opacity-100 pt-[20px] pb-[20px]"
                      : "-mb-10 opacity-0"
                      } tile-inlay-primary font-normal text-[18px] duration-300 ease-in-out tracking-wider`}>
                    <FullName />
                  </h4>
              </div>
              <Logo
                logo_letter="true"
                className="max-h-[60px] h-full w-[auto] object-contain rounded-full"
              />
            </div>
            {/* Lifetime points box end*/}
          </div>
          <div className="relative z-10 mb-10">
            {/* Expanded box  */}
            <div
              className={`${this.state.toggleBox ? "toggler" : "h-10"}
                   absolute top-0 z-10 left-0 right-0 transition-[height] duration-300 ease-in-out bg-tile rounded-b-4xl w-full px-10 overflow-hidden`}>
              <div className="h-10" />
              {/* horizontal line*/}
              <div className="flex items-center justify-center">
                <div
                  className="absolute z-20 bottom-3"
                  onClick={this.toggleBox}>
                  <div className="w-12 h-1 mx-auto mt-5 rounded-full bg-body bg-opacity-40 " />
                </div>
              </div>

              {/* Expanded box content start*/}
              <div className="text-center">
                <div>
                  <p className="tile-inlay-primary opacity-50 text-[15px] uppercase font-normal tracking-wider leading-8">
                    Fan Rank
                  </p>
                  <div className="flex items-center justify-center gap-x-1">
                    <p className="tile-inlay-primary font-medium text-[18px] uppercase tracking-wider leading-8">
                      {numberFormat(this.props.score.fans_rank)}
                    </p>
                    <div className="tile-inlay-primary opacity-50">/</div>
                    <p className="tile-inlay-primary opacity-50 font-normal text-[18px] uppercase tracking-wider leading-8">
                      {numberFormat(this.props.score.total_fans_rank)}
                    </p>
                  </div>
                  <LinkTo
                    to={`/${cname}/${pname}/leaderboard`}
                    text="View Leaderboard"
                    className="uppercase font-medium text-[14px] tile-inlay-primary leading-8"
                  />
                </div>
                <div className="my-5">
                  {/* <p className="text-primary opacity-50 text-[15px] uppercase tracking-wider font-normal">
                    Points Redeemed
                  </p>
                  <p className="text-primary font-semibold text-[18px] uppercase tracking-wider">
                    {numberFormat(lifetime_points - points_redeemed)}
                  </p> */}
                </div>
                <ProgramBox box="POWERED_BY"></ProgramBox>
              </div>
              {/* Expanded box content end*/}

              {/* Expanded box add wallet action start*/}
              {/*<div className="add-wallet fixed bottom-[-50px] z-20 transition-[bottom] duration-300 ease-in-out text-center left-0 right-0">
                <Buttonlink
                  onClick={(): void => this.setState({ toggleBox: false })}
                  text="+ add to wallet"
                  className="flex items-center px-4 py-2 mx-auto font-medium rounded-full gap-x-1 bg-primary"
                />
              </div>*/}
              {/* Expanded box add wallet action end*/}
            </div>
          </div>
        </div>
        {/* backdrop start*/}
        {this.state.toggleBox && (
          <div
            onClick={this.toggleBox}
            className={`${this.state.toggleBox ? "bg-[#000]/80" : "bg-[#000]/20"
              }  h-full fixed z-20 w-full top-0`}
          />
        )}
        {/* backdrop end*/}
      </div>
    );
  }
}
const mapStateToProps = ({ user, score, util, creator }) => {
  return {
    user: user.user,
    pageYOffset: (util?.pageYOffset || 0),
    score: score,
    lifetime_points: score.lifetime_points,
    creator: creator,
    points_redeemed: score.points_redeemed,
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions } = require("@redux/UserRedux");
  return {
    ...stateProps,
  };
};

export default connect(
  mapStateToProps,
  undefined,
  mergeProps
)(MobilePointStats);
